<script lang="ts">
import { defineComponent } from "vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "OnlineKeinAngebot",
  setup() {
    const piniaStore = useFormStore();

    return {
      piniaStore,
    };
  },
});
</script>

<template>
  <div v-if="piniaStore.state.isMakler">Dieses Risiko ist nicht versicherbar.</div>
  <div v-else>Aufgrund Ihrer Angabe können wir Ihnen leider keinen Versicherungsschutz anbieten.</div>
</template>
